// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__v6Aum","employee-header__buttons":"Header_employee-header__buttons__0+0pj","employee-header-item":"Header_employee-header-item__F2942"};